export default "__VITE_ASSET__DtOgTAMH__"